import {ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, ViewChild} from "@angular/core";
import {ISvgIcon} from "../../interfaces/svg.icon";
import {ISvgIconGraphics, SvgIconGraphicsType} from "../../interfaces/svg.icon.graphics";

@Component({
	selector:'cp-svg-icon-definition',
	templateUrl: './svg.icon.definition.html',
	styleUrls: ['./svg.icon.definition.style.scss'],
	changeDetection:ChangeDetectionStrategy.OnPush,
})
export class SvgIconDefinitionComponent implements OnInit {
	@Input() svgIcon: ISvgIcon;

	@ViewChild('symbol',{static:true}) public svgSymbolElement:ElementRef;

	public nodes: ISvgIconGraphics[] = [];
	public svgIconGraphicsTypes = SvgIconGraphicsType;

	public get iconId() {
		return this.svgIcon ? (this.svgIcon.system ? this.svgIcon.name : (this.svgIcon.key ? this.svgIcon.key.toString() : '')) : '';
	}

	ngOnInit(): void {
		this.handleGraphics();
	}

	public handleGraphics() {
		let xml = (new DOMParser()).parseFromString(this.svgIcon.graphics, "text/xml");
		if (xml && xml.documentElement && xml.documentElement.childNodes && xml.documentElement.childNodes.length){
			this.setAttributes(xml,"viewBox");
			this.setAttributes(xml,"width");
			this.setAttributes(xml,"height");

			let children = Array.from(xml.documentElement.childNodes).filter(n => n.nodeType === 1);
			children.forEach(child => this.nodes.push(this.handleNode(child)));
		}
	}

	private setAttributes(xmlNode, attribute: string) {
		// xml structure for chromium and IE
		let attributeNode = (xmlNode.children && xmlNode.children[0].attributes && xmlNode.children[0].attributes[attribute])
			? xmlNode.children[0].attributes[attribute]
			: (xmlNode.childNodes && xmlNode.childNodes[0].attributes && xmlNode.childNodes[0].attributes[attribute])
				? xmlNode.childNodes[0].attributes[attribute] : null;
		if (attributeNode) {
			let value = attributeNode.value;
			this.svgSymbolElement.nativeElement.setAttribute(attribute, value);
		}
	}

	private handleNode(currNode	:Node) {
		let node: ISvgIconGraphics = {
			type: <any>SvgIconGraphicsType[currNode.nodeName.toLowerCase()],
			attributes: {},
			subNodes:[]
		};

		if (node.type === SvgIconGraphicsType.g) {
			let children = Array.from(currNode.childNodes).filter(n => n.nodeType === 1);
			children.forEach(currChild => node.subNodes.push(this.handleNode(currChild)));
		}
		let attributes = Array.from(currNode['attributes']);
		attributes.forEach(attr => {
			node.attributes[attr['name'].replace('-', '')] = attr['value'];
		});

		return node;
	}
}
